import React from 'react';

import {cn} from '../lib/helpers';

import {full, fixed, header, withSidebar} from './container.module.css';

const Container = ({children, as: As = 'div', variant, className, ...rest}) => {
  let variantClassName = null;
  switch (variant) {
    case 'full':
      variantClassName = full;
      break;
    case 'fixed':
      variantClassName = fixed;
      break;
    case 'header':
      variantClassName = header;
      break;
    case 'withSidebar':
      variantClassName = withSidebar;
      break;
    default:
      variantClassName = full;
      break;
  }

  return (
    <As className={cn(variantClassName, className && className)} {...rest}>
      {children}
    </As>
  );
};

export default Container;
